export const PURCHASE_STATUS_TEXT = {
    draft: {
        label: 'Rascunho',
        tone: 'neutral',
        what: 'Ainda é só uma lista: sem número, e nada foi pedido ao fornecedor.',
        next: 'Confirmar quando o pedido for feito de verdade.',
    },
    confirmed: {
        label: 'Confirmada',
        tone: 'warning',
        what: 'O pedido foi feito e a loja está esperando a mercadoria chegar. É esta que se cobra do fornecedor quando atrasa.',
        next: 'Receber quando a mercadoria chegar, conferindo as quantidades.',
    },
    received: {
        label: 'Recebida',
        tone: 'success',
        what: 'A mercadoria chegou e entrou no estoque, pelo custo desta nota.',
    },
    cancelled: {
        label: 'Cancelada',
        tone: 'danger',
        what: 'A compra foi desfeita e não espera mais entrega. O motivo fica no histórico.',
    },
};
export const PURCHASE_LEGEND_TEXT = [
    PURCHASE_STATUS_TEXT.draft,
    PURCHASE_STATUS_TEXT.confirmed,
    PURCHASE_STATUS_TEXT.received,
    PURCHASE_STATUS_TEXT.cancelled,
];
//# sourceMappingURL=purchasing.js.map